// Enums — alignés avec les CHECK constraints des migrations SQL

export const USER_ROLES = [
  'owner',
  'manager',
  'cashier',
  'patient',
  'driver',
  'doctor',
  'super_admin',
] as const
export type UserRole = (typeof USER_ROLES)[number]

export const PHARMACY_PLANS = ['free', 'standard', 'premium'] as const
export type PharmacyPlan = (typeof PHARMACY_PLANS)[number]

export const PAYMENT_METHODS = [
  'cash',
  'mtn_momo',
  'orange_money',
  'camerpay',
  'card',
  'credit',
] as const
export type PaymentMethod = (typeof PAYMENT_METHODS)[number]

export const ACCOUNTING_PAYMENT_MODES = [
  'cash',
  'mtn_momo',
  'orange_money',
  'camerpay',
  'virement',
  'card',
] as const
export type AccountingPaymentMode = (typeof ACCOUNTING_PAYMENT_MODES)[number]

export const PAYMENT_STATUS = [
  'pending',
  'processing',
  'completed',
  'failed',
  'refunded',
  'cancelled',
] as const
export type PaymentStatus = (typeof PAYMENT_STATUS)[number]

export const SALE_STATUS = ['completed', 'refunded', 'partial_refund'] as const
export type SaleStatus = (typeof SALE_STATUS)[number]

export const DELIVERY_STATUS = [
  'quote_pending',
  'quote_sent',
  'pending',
  'paid',
  'assigned',
  'in_transit',
  'ready_for_pickup',
  'delivered',
  'cancelled',
] as const
export type DeliveryStatus = (typeof DELIVERY_STATUS)[number]

export const DELIVERY_MODE = ['delivery', 'click_collect'] as const
export type DeliveryMode = (typeof DELIVERY_MODE)[number]

export const ACCOUNTING_TYPES = ['recette', 'depense'] as const
export type AccountingType = (typeof ACCOUNTING_TYPES)[number]

export const ACCOUNTING_STATUS = ['en_attente', 'valide'] as const
export type AccountingStatus = (typeof ACCOUNTING_STATUS)[number]

export const LOYALTY_OPERATIONS = ['earn', 'spend', 'expire', 'bonus'] as const
export type LoyaltyOperation = (typeof LOYALTY_OPERATIONS)[number]

export const LOYALTY_ENTITY_TYPES = ['patient', 'pharmacy'] as const
export type LoyaltyEntityType = (typeof LOYALTY_ENTITY_TYPES)[number]

export const NOTIFICATION_CHANNELS = ['push', 'sms', 'whatsapp'] as const
export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number]

export const NOTIFICATION_STATUS = ['sent', 'failed', 'pending'] as const
export type NotificationStatus = (typeof NOTIFICATION_STATUS)[number]

export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'] as const
export type BloodGroup = (typeof BLOOD_GROUPS)[number]

export const VITAL_SIGN_TYPES = ['blood_pressure', 'glucose', 'weight', 'temperature'] as const
export type VitalSignType = (typeof VITAL_SIGN_TYPES)[number]

export const REMINDER_FREQUENCIES = ['daily', 'twice_daily', 'weekly'] as const
export type ReminderFrequency = (typeof REMINDER_FREQUENCIES)[number]

export const PRESCRIPTION_STATUS = ['active', 'dispensed', 'expired'] as const
export type PrescriptionStatus = (typeof PRESCRIPTION_STATUS)[number]

export const CONTRACT_TYPES = ['CDI', 'CDD', 'Stage'] as const
export type ContractType = (typeof CONTRACT_TYPES)[number]
